import axios from './base/axios';
import { apiUrl as baseApiUrl } from './base/axios';
import get from './base/get';
import post from './base/post';
import patch from './base/patch';
import put from './base/put';
import deleteRequest from './base/delete';
export const API_BASE_URL = baseApiUrl;
export { axios, get, post, patch, put, deleteRequest, };
export { apiUrl, defaultParams, setNotificationAdapter, } from './base/axios';
